var w = Object.defineProperty;
var x = (n, t, e) => t in n ? w(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var o = (n, t, e) => (x(n, typeof t != "symbol" ? t + "" : t, e), e);
import { EditorView as D } from "@codemirror/view";
const v = {
  /**
   * URL where the file will be send
   */
  uploadUrl: "/upload",
  /**
   * Which method will be used to send the file to the upload URL
   */
  uploadMethod: "POST",
  /**
   * Name in which the file will be placed
   */
  uploadFieldName: "file",
  /**
   * Extension which will be used when a file extension could not
   * be detected
   */
  defaultExtension: "png",
  /**
   * JSON field which refers to the uploaded file URL
   */
  responseUrlKey: "url",
  /**
   * Allowed MIME types
   */
  allowedTypes: [
    "image/jpeg",
    "image/png",
    "image/jpg",
    "image/gif"
  ],
  /**
   * Text which will be inserted when dropping or pasting a file.
   * Acts as a placeholder which will be replaced when the file is done with uploading
   */
  progressText: "![Uploading file...]()",
  /**
   * When a file has successfully been uploaded the progressText
   * will be replaced by the urlText, the {url} tag will be replaced response url
   */
  urlText: "![{alt}]({url})",
  /**
   * Text which will be used when uploading has failed
   */
  errorText: "Error uploading file",
  /**
   * Extra parameters which will be send when uploading a file
   */
  extraParams: {},
  /**
   * Extra headers which will be send when uploading a file
   */
  extraHeaders: {},
  /**
   * Before the file is send
   */
  beforeFileUpload() {
    return !0;
  },
  /**
   * Triggers when a file is dropped or pasted
   */
  onFileReceived() {
    return !0;
  },
  /**
   * Custom upload handler
   *
   * @return {Boolean} when false is returned it will prevent default upload behavior
   */
  onFileUploadSucceed() {
    return !0;
  },
  /**
   * Custom error handler. Runs after removing the placeholder text and before the alert().
   * Return false from this function to prevent the alert dialog.
   *
   * @return {Boolean} when false is returned it will prevent default error behavior
   */
  onFileUploadError() {
    return !0;
  },
  /**
   * When a file has successfully been uploaded
   */
  onFileUploaded() {
  }
};
async function P({
  url: n,
  ...t
}) {
  try {
    const e = await fetch(n, t);
    if (!e.ok)
      throw new Error(e.statusText);
    return {
      ok: !0,
      value: await e.json()
    };
  } catch (e) {
    return {
      ok: !1,
      value: e
    };
  }
}
function V(n) {
  return typeof n == "function";
}
function T(n, t = "", e = "") {
  const r = t.split(".");
  let a = n;
  for (const s of r)
    if (a && typeof a == "object" && s in a)
      a = a[s];
    else
      return e;
  return a !== void 0 ? a : e;
}
class E {
  constructor(t, e) {
    o(this, "options", v);
    o(this, "editor");
    o(this, "filename", "");
    o(this, "lastValue", "");
    this.editor = t, this.options = { ...v, ...e };
  }
  /** Uploads file */
  async uploadFile(t) {
    const {
      defaultExtension: e,
      remoteFilename: r,
      uploadFieldName: a,
      extraParams: s,
      extraHeaders: l,
      uploadUrl: d,
      uploadMethod: p,
      beforeFileUpload: c
    } = this.options, i = new FormData();
    let f = e;
    if (t.name) {
      const [u] = t.name.match(/\.(.+)$/) || [];
      u && (f = u);
    }
    const g = (r == null ? void 0 : r(t)) || `image-${Date.now()}.${f}`;
    if (this.filename = g, i.append(a, t, g), Object.keys(s).forEach((u) => {
      i.append(u, s[u]);
    }), !(c != null && c(i)))
      return;
    const { ok: F, value: m } = await P({
      url: d,
      method: p,
      body: i,
      headers: l
    });
    if (!F) {
      this.onFileUploadError(m);
      return;
    }
    this.onFileUploadSucceed(m);
  }
  /**
   * Returns if the given file is allowed to handle
   */
  isFileAllowed(t) {
    const { allowedTypes: e } = this.options;
    return e.includes("*") || e.includes(t.type);
  }
  /**
   * Handles upload response
   */
  onFileUploadSucceed(t) {
    var c, i;
    const { onFileUploadSucceed: e, urlText: r, responseUrlKey: a } = this.options;
    if (!(e != null && e(t)) || !this.lastValue)
      return;
    const s = T(t, a) || "unknown URL";
    if (!s)
      return;
    const l = /!\[({[^}]+})]\(([^)]+)\)/, d = V(r) ? r(s, t) : r.replace(r.match(l)[1], this.filename).replace(r.match(l)[2], s), p = this.editor.getValue().replace(this.lastValue, d);
    this.editor.setValue(p), (i = (c = this.options).onFileUploaded) == null || i.call(c, s);
  }
  /**
   * Called when a file has failed to upload
   */
  onFileUploadError(t) {
    var r, a;
    if (!((a = (r = this.options).onFileUploadError) != null && a.call(r, t)) || !this.lastValue)
      return;
    const e = this.editor.getValue().replace(this.lastValue, this.options.errorText);
    this.editor.setValue(e);
  }
  /**
   * Called when a file has been inserted, either by drop or paste
   */
  onFileInserted(t) {
    var e, r;
    (r = (e = this.options).onFileReceived) != null && r.call(e, t) && (this.lastValue = this.options.progressText, this.editor.insertValue(this.lastValue));
  }
  handleFiles(t) {
    Array.from(t).forEach((e) => {
      this.isFileAllowed(e) && (this.onFileInserted(e), this.uploadFile(e));
    });
  }
  /**
   * Called when a paste event occurred
   */
  onPaste(t) {
    var e;
    t.preventDefault(), (e = t.clipboardData) != null && e.files.length && this.handleFiles(t.clipboardData.files);
  }
  /**
   * Called when a drop event occurred
   */
  onDrop(t) {
    var e;
    t.preventDefault(), (e = t.dataTransfer) != null && e.files.length && this.handleFiles(t.dataTransfer.files);
  }
}
function A(n, t) {
  const e = n.scrollTop;
  let r = 0, a = !1, s;
  n.selectionStart || n.selectionStart === 0 ? a = "ff" : document.selection && (a = "ie"), a === "ie" ? (n.focus(), s = document.selection.createRange(), s.moveStart("character", -n.value.length), r = s.text.length) : a === "ff" && (r = n.selectionStart || 0);
  const l = n.value.substring(0, r), d = n.value.substring(r, n.value.length);
  n.value = l + t + d, r += t.length, a === "ie" ? (n.focus(), s = document.selection.createRange(), s.moveStart("character", -n.value.length), s.moveStart("character", r), s.moveEnd("character", 0), s.select()) : a === "ff" && (n.selectionStart = r, n.selectionEnd = r, n.focus()), n.scrollTop = e;
}
class U {
  constructor(t) {
    o(this, "instance");
    this.instance = t;
  }
  getValue() {
    return this.instance.value;
  }
  insertValue(t) {
    A(this.instance, t);
  }
  setValue(t) {
    this.instance.value = t;
  }
}
class y extends E {
  constructor(t, e = {}) {
    super(new U(t), e);
  }
  bind() {
    this.editor.instance.addEventListener(
      "paste",
      (t) => {
        this.onPaste(t);
      },
      !1
    ), this.editor.instance.addEventListener(
      "drop",
      (t) => {
        t.stopPropagation(), t.preventDefault(), this.onDrop(t);
      },
      !1
    ), this.editor.instance.addEventListener(
      "dragenter",
      (t) => {
        t.stopPropagation(), t.preventDefault();
      }
    ), this.editor.instance.addEventListener(
      "dragover",
      (t) => {
        t.stopPropagation(), t.preventDefault();
      }
    );
  }
}
function k(...n) {
  return new y(...n).bind();
}
class b {
  constructor(t) {
    o(this, "instance");
    this.instance = t;
  }
  getValue() {
    return this.instance.state.doc.toString();
  }
  insertValue(t) {
    this.instance.dispatch(this.instance.state.replaceSelection(t));
  }
  setValue(t) {
    const e = this.instance.state.selection.main.head;
    this.instance.dispatch({
      changes: {
        from: 0,
        to: this.instance.state.doc.length,
        insert: t
      }
    }), this.instance.dispatch({ selection: { anchor: e } });
  }
}
class h extends E {
  constructor(t, e = {}) {
    super(new b(t), e);
  }
  bind() {
    this.editor.instance.dom.addEventListener(
      "paste",
      (t) => {
        this.onPaste(t);
      },
      !1
    ), this.editor.instance.dom.addEventListener(
      "drop",
      (t) => {
        t.stopPropagation(), t.preventDefault(), this.onDrop(t);
      },
      !1
    ), this.editor.instance.dom.addEventListener(
      "dragenter",
      (t) => {
        t.stopPropagation(), t.preventDefault();
      }
    ), this.editor.instance.dom.addEventListener(
      "dragover",
      (t) => {
        t.stopPropagation(), t.preventDefault();
      }
    );
  }
}
function I(...n) {
  return new h(...n).bind();
}
function M(n = {}) {
  return D.domEventHandlers({
    paste: (t, e) => {
      new h(e, n).onPaste(t);
    },
    drop: (t, e) => {
      t.stopPropagation(), t.preventDefault(), new h(e, n).onDrop(t);
    },
    dragenter: (t) => {
      t.stopPropagation(), t.preventDefault();
    },
    dragover: (t) => {
      t.stopPropagation(), t.preventDefault();
    }
  });
}
export {
  h as CodeMirrorInlineAttachmentAdapter,
  v as DEFAULT_OPTIONS,
  E as InlineAttachment,
  y as InputInlineAttachmentAdapter,
  k as attach,
  I as attachCodeMirror,
  M as inlineAttachmentExtension
};
